import { render } from "./LocalLoader.vue?vue&type=template&id=472452ea&scoped=true"
const script = {}

import "./LocalLoader.vue?vue&type=style&index=0&id=472452ea&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472452ea"]])

export default __exports__